var _defs, _rect, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 48,
    viewBox: "0 0 220 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgl",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667eea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764ba2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 40,
    height: 40,
    rx: 11,
    fill: "url(#bgl)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 30 L13 18 L20 26 L27 18 L33 30",
    stroke: "white",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 31,
    fontFamily: "-apple-system, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "white"
  }, "LeadWix")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.f1a4269f365aa8b0255af07c919a2ae7.svg";
export { ForwardRef as ReactComponent };